import {Dispatch} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {ReducerState} from '@taopix/taopix-core/dist/types/types';
import {SettingsActions} from '@taopix/taopix-core';
import {ActionType} from 'typesafe-actions';

const useSettings = () => {
  const state = useSelector((state: ReducerState) => state.settings);

  return {
    state,
    dispatch: useDispatch<Dispatch<ActionType<typeof SettingsActions>>>(),
  };
};

export default useSettings;
